import create from "zustand";

const initialState = {
	conponData: null,
	confirmModal: null,
};

const appStore = create((set) => ({
	...initialState,
	setConfirmModal: (data: any) => set({ confirmModal: data }),
	setCouponData: (couponData: any) => set({ couponData }),
}));

export default appStore;
